import { create } from "zustand";
import { persist } from "zustand/middleware";

const emptyUser = {
	user_id: null,
	customer_id: null,
	name: "",
	customer_name: "",
	superuser: 0,
};

export const mapAuthUserToStoreUser = (authUser) => ({
	user_id: authUser?.user_id ?? null,
	customer_id: authUser?.customer?.id ?? authUser?.customer_id ?? null,
	name: authUser?.full_name ?? authUser?.name ?? "",
	customer_name: authUser?.customer?.name ?? authUser?.customer_name ?? "",
	superuser: authUser?.superuser ?? 0,
});

const useUserStore = create(
	persist(
		(set) => ({
			user: { ...emptyUser },

			setUser: (newUser) => set({ user: newUser }),

			setUserFromAuth: (authUser) => set({ user: mapAuthUserToStoreUser(authUser) }),

			resetUser: () => set({ user: { ...emptyUser } }),
		}),
		{
			name: "agroinventario-user-storage",
		},
	),
);

export default useUserStore;
